import { routeNames } from './routeNames';

function loadView(view) {
  return () => import(`@/views/${view}.vue`);
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: loadView('Login'),
  },
  {
    path: '/login/redirect',
    name: 'loading-screen',
    component: loadView('LoadingScreen'),
  },
  {
    path: '/reset-password',
    name: 'reset-password-request',
    component: loadView('SendResetPassword'),
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: loadView('ResetPassword'),
    props: route => ({
      token: route.params.token,
    }),
  },
  {
    path: '/activate/:token',
    name: 'activate',
    component: loadView('ActivateAccount'),
    props: route => ({
      token: route.params.token,
    }),
  },
  {
    path: '/',
    component: loadView('Page'),
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        meta: {
          title: 'DASHBOARD',
          icon: 'dashboard',
        },
        component: loadView('Dashboard'),
        children: [],
      },
      {
        path: '/settings',
        meta: {
          title: 'SETTINGS',
          icon: 'settings',
        },
        component: loadView('Settings'),
        children: [
          {
            path: '',
            name: 'settings',
            component: loadView('Settings/General'),
            children: [
              {
                path: 'change_pwd',
                name: routeNames.USER_CHANGE_PWD,
                component: loadView('Settings/ChangePassword'),
                children: [],
              },
              {
                path: 'app',
                name: routeNames.APP_SETTINGS,
                component: loadView('Settings/AppSettings'),
                children: [],
              },
            ],
          },
        ],
      }, {
        path: '/communications',
        meta: {
          title: 'COMMUNICATIONS',
          icon: 'send',
          section: 'COMMUNICATION',
        },
        component: loadView('Communications'),
        children: [
          {
            path: '',
            name: 'communications',
            component: loadView('Communications/CommunicationList'),
          },

          {
            path: 'new',
            name: routeNames.COMMUNICATION_NEW,
            meta: {
              title: 'NEW',
            },
            component: loadView('Communications/CommunicationNew'),
          },
          {
            path: ':id',
            component: loadView('Communications/Communication'),
            name: 'communication',
            meta: {
              title: 'COMMUNICATION',
            },
            redirect: { name: routeNames.COMMUNICATION_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('Communications/CommunicationShow'),
                name: routeNames.COMMUNICATION_SHOW,
                props: route => ({
                  id: route.params.id,
                  tab: route.params.tab,
                }),
              },
              {
                path: 'edit',
                component: loadView('Communications/CommunicationNew'),
                name: routeNames.COMMUNICATION_EDIT,
                meta: {
                  title: 'EDIT',
                  icon: 'edit',
                },
                props: route => ({
                  id: route.params.id,
                }),
              },
              {
                path: 'send',
                component: loadView('Communications/CommunicationSend'),
                name: routeNames.COMMUNICATION_SEND,
                meta: {
                  title: 'SEND',
                  icon: 'send',
                },
                props: route => ({
                  id: route.params.id,
                }),
              },
            ],
          },
        ],
      }, {
        path: '/users',
        meta: {
          title: 'USERS',
          icon: 'person',
          section: 'MANAGE_USERS',
        },
        component: loadView('Users'),
        children: [
          {
            path: '',
            name: routeNames.USER,
            component: loadView('Users/UserList'),
            children: [],
          },
          {
            path: ':id',
            component: loadView('Users/User'),
            name: 'user',
            meta: {
              title: 'USER',
            },
            redirect: { name: routeNames.USER_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('Users/UserShow'),
                name: routeNames.USER_SHOW,
                props: route => ({
                  id: route.params.id,
                  tab: route.params.tab,
                }),
              },
            ],
          },
        ],
      }, {
        path: '/editors',
        meta: {
          title: 'EDITORS',
          icon: 'person',
          section: 'BASIC_ARCHIVES',
        },
        component: loadView('Editors'),
        children: [
          {
            path: '',
            name: routeNames.EDITOR,
            component: loadView('Editors/EditorList'),
            children: [],
          },
          {
            path: 'new',
            component: loadView('Editors/EditorForm'),
            name: routeNames.EDITOR_NEW,
            meta: {
              title: 'NEW',
            },
          },
          {
            path: ':id',
            component: loadView('Editors/Editor'),
            name: 'editor',
            meta: {
              title: 'EDITOR',
            },
            redirect: { name: routeNames.EDITOR_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('Editors/EditorShow'),
                name: routeNames.EDITOR_SHOW,
                props: route => ({
                  id: route.params.id,
                  tab: route.params.tab,
                }),
              },
              {
                path: 'edit',
                component: loadView('Editors/EditorForm'),
                name: routeNames.EDITOR_EDIT,
                meta: {
                  title: 'EDIT',
                  icon: 'edit',
                },
                props: route => ({
                  id: route.params.id,
                }),
              },
            ],
          },
        ],
      }, {
        path: '/editors_group',
        meta: {
          title: 'EDITORS_GROUP',
          icon: 'person',
          section: 'BASIC_ARCHIVES',
        },
        component: loadView('EditorsGroup'),
        children: [
          {
            path: '',
            name: routeNames.EDITOR_GROUP,
            component: loadView('EditorsGroup/EditorGroupList'),
            children: [],
          },
          {
            path: 'new',
            component: loadView('EditorsGroup/EditorGroupForm'),
            name: routeNames.EDITOR_GROUP_NEW,
            meta: {
              title: 'NEW',
            },
          },
          {
            path: ':id',
            component: loadView('EditorsGroup/EditorGroup'),
            name: 'editor_group',
            meta: {
              title: 'EDITORS_GROUP',
            },
            redirect: { name: routeNames.EDITOR_GROUP_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('EditorsGroup/EditorGroupShow'),
                name: routeNames.EDITOR_GROUP_SHOW,
                props: route => ({
                  id: route.params.id,
                  tab: route.params.tab,
                }),
              },
              {
                path: 'edit',
                component: loadView('EditorsGroup/EditorGroupForm'),
                name: routeNames.EDITOR_GROUP_EDIT,
                meta: {
                  title: 'EDIT',
                  icon: 'edit',
                },
                props: route => ({
                  id: route.params.id,
                }),
              },
            ],
          },
        ],
      }, {
        path: '/books',
        meta: {
          title: 'BOOKS',
          icon: 'menu_book',
          section: 'BASIC_ARCHIVES',
        },
        component: loadView('Books'),
        children: [
          {
            path: '',
            name: routeNames.BOOK,
            component: loadView('Books/BookList'),
            children: [],
          },
          {
            path: 'import',
            component: loadView('Books/BookImport'),
            name: routeNames.BOOK_IMPORT,
            meta: {
              title: 'IMPORT',
            },
          },
          {
            path: 'new',
            component: loadView('Books/BookForm'),
            name: routeNames.BOOK_NEW,
            meta: {
              title: 'NEW',
            },
          },
          {
            path: ':id',
            component: loadView('Books/Book'),
            name: 'book',
            meta: {
              title: 'BOOK',
            },
            redirect: { name: routeNames.BOOK_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('Books/BookShow'),
                name: routeNames.BOOK_SHOW,
                props: route => ({
                  id: route.params.id,
                  tab: route.params.tab,
                }),
              },
              {
                path: 'edit',
                component: loadView('Books/BookForm'),
                name: routeNames.BOOK_EDIT,
                meta: {
                  title: 'EDIT',
                  icon: 'edit',
                },
                props: route => ({
                  id: route.params.id,
                }),
              },
            ],
          },
        ],
      }, {
        path: '/teachers',
        meta: {
          title: 'TEACHERS',
          icon: 'person',
          section: 'BASIC_ARCHIVES',
        },
        component: loadView('Teachers'),
        children: [
          {
            path: '',
            name: routeNames.TEACHER,
            component: loadView('Teachers/TeacherList'),
            children: [],
          },
          {
            path: 'new',
            component: loadView('Teachers/TeacherForm'),
            name: routeNames.TEACHER_NEW,
            meta: {
              title: 'NEW',
            },
          },
          {
            path: ':id',
            component: loadView('Teachers/Teacher'),
            name: 'teacher',
            meta: {
              title: 'TEACHER',
            },
            redirect: { name: routeNames.TEACHER_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('Teachers/TeacherShow'),
                name: routeNames.TEACHER_SHOW,
                props: route => ({
                  id: route.params.id,
                  tab: route.params.tab,
                }),
              },
              {
                path: 'edit',
                component: loadView('Teachers/TeacherForm'),
                name: routeNames.TEACHER_EDIT,
                meta: {
                  title: 'EDIT',
                  icon: 'edit',
                },
                props: route => ({
                  id: route.params.id,
                }),
              },
            ],
          },
        ],
      }, {
        path: '/propagandists',
        meta: {
          title: 'PROPAGANDISTS',
          icon: 'person',
          section: 'BASIC_ARCHIVES',
        },
        component: loadView('Propagandists'),
        children: [
          {
            path: '',
            name: routeNames.PROPAGANDIST,
            component: loadView('Propagandists/PropagandistList'),
            children: [],
          },
          {
            path: 'new',
            component: loadView('Propagandists/PropagandistForm'),
            name: routeNames.PROPAGANDIST_NEW,
            meta: {
              title: 'NEW',
            },
          },
          {
            path: ':id',
            component: loadView('Propagandists/Propagandist'),
            name: 'propagandist',
            meta: {
              title: 'PROPAGANDIST',
            },
            redirect: { name: routeNames.PROPAGANDIST_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('Propagandists/PropagandistShow'),
                name: routeNames.PROPAGANDIST_SHOW,
                props: route => ({
                  id: route.params.id,
                  tab: route.params.tab,
                }),
              },
              {
                path: 'edit',
                component: loadView('Propagandists/PropagandistForm'),
                name: routeNames.PROPAGANDIST_EDIT,
                meta: {
                  title: 'EDIT',
                  icon: 'edit',
                },
                props: route => ({
                  id: route.params.id,
                }),
              },
            ],
          },
        ],
      }, {
        path: '/schools',
        meta: {
          title: 'SCHOOLS',
          icon: 'school',
          section: 'BASIC_ARCHIVES',
        },
        component: loadView('Schools'),
        children: [
          {
            path: '',
            name: routeNames.SCHOOL,
            component: loadView('Schools/SchoolList'),
            children: [],
          },
          {
            path: 'new',
            component: loadView('Schools/SchoolForm'),
            name: routeNames.SCHOOL_NEW,
            meta: {
              title: 'NEW',
            },
          },
          {
            path: ':id',
            component: loadView('Schools/School'),
            name: 'school',
            meta: {
              title: 'SCHOOL',
            },
            redirect: { name: routeNames.SCHOOL_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('Schools/SchoolShow'),
                name: routeNames.SCHOOL_SHOW,
                props: route => ({
                  id: route.params.id,
                  tab: route.params.tab,
                }),
              },
              {
                path: 'grid',
                component: loadView('Schools/SchoolGrid'),
                name: routeNames.SCHOOL_GRID,
                props: route => ({
                  id: route.params.id,
                }),
              },
              {
                path: 'edit',
                component: loadView('Schools/SchoolForm'),
                name: routeNames.SCHOOL_EDIT,
                meta: {
                  title: 'EDIT',
                  icon: 'edit',
                },
                props: route => ({
                  id: route.params.id,
                }),
              },
            ],
          },
        ],
      }, {
        path: '/schools_type',
        meta: {
          title: 'SCHOOL_TYPE',
          icon: 'person',
          section: 'BASIC_ARCHIVES',
        },
        component: loadView('SchoolsType'),
        children: [
          {
            path: '',
            name: routeNames.SCHOOL_TYPE,
            component: loadView('SchoolsType/SchoolTypeList'),
            children: [],
          },
          {
            path: 'new',
            component: loadView('SchoolsType/SchoolTypeForm'),
            name: routeNames.SCHOOL_TYPE_NEW,
            meta: {
              title: 'NEW',
            },
          },
          {
            path: ':id',
            component: loadView('SchoolsType/SchoolType'),
            name: 'school_type',
            meta: {
              title: 'SCHOOL_TYPE',
            },
            redirect: { name: routeNames.SCHOOL_TYPE_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('SchoolsType/SchoolTypeShow'),
                name: routeNames.SCHOOL_TYPE_SHOW,
                props: route => ({
                  id: route.params.id,
                  tab: route.params.tab,
                }),
              },
              {
                path: 'edit',
                component: loadView('SchoolsType/SchoolTypeForm'),
                name: routeNames.SCHOOL_TYPE_EDIT,
                meta: {
                  title: 'EDIT',
                  icon: 'edit',
                },
                props: route => ({
                  id: route.params.id,
                }),
              },
            ],
          },
        ],
      },
      {
        path: '/zones',
        meta: {
          title: 'ZONE',
          icon: 'map',
          section: 'BASIC_ARCHIVES',
        },
        component: loadView('Zones'),
        children: [
          {
            path: '',
            name: routeNames.ZONE,
            component: loadView('Zones/ZoneList'),
            children: [],
          },
          {
            path: 'new',
            component: loadView('Zones/ZoneForm'),
            name: routeNames.ZONE_NEW,
            meta: {
              title: 'NEW',
            },
          },
          {
            path: ':id',
            component: loadView('Zones/Zone'),
            name: 'zone',
            meta: {
              title: 'ZONE',
            },
            redirect: { name: routeNames.ZONE_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('Zones/ZoneShow'),
                name: routeNames.ZONE_SHOW,
                props: route => ({
                  id: route.params.id,
                  tab: route.params.tab,
                }),
              },
              {
                path: 'edit',
                component: loadView('Zones/ZoneForm'),
                name: routeNames.ZONE_EDIT,
                meta: {
                  title: 'EDIT',
                  icon: 'edit',
                },
                props: route => ({
                  id: route.params.id,
                }),
              },
            ],
          },
        ],
      }, {
        path: '/subjects',
        meta: {
          title: 'SUBJECTS',
          icon: 'subject',
          section: 'BASIC_ARCHIVES',
        },
        component: loadView('Subjects'),
        children: [
          {
            path: '',
            name: routeNames.SUBJECT,
            component: loadView('Subjects/SubjectList'),
            children: [],
          },
          {
            path: 'new',
            component: loadView('Subjects/SubjectForm'),
            name: routeNames.SUBJECT_NEW,
            meta: {
              title: 'NEW',
            },
          },
          {
            path: ':id',
            component: loadView('Subjects/Subject'),
            name: 'subject',
            meta: {
              title: 'SUBJECT',
            },
            redirect: { name: routeNames.SUBJECT_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('Subjects/SubjectShow'),
                name: routeNames.SUBJECT_SHOW,
                props: route => ({
                  id: route.params.id,
                  tab: route.params.tab,
                }),
              },
              {
                path: 'edit',
                component: loadView('Subjects/SubjectForm'),
                name: routeNames.SUBJECT_EDIT,
                meta: {
                  title: 'EDIT',
                  icon: 'edit',
                },
                props: route => ({
                  id: route.params.id,
                }),
              },
            ],
          },
        ],
      }, {
        path: '/warehouses',
        meta: {
          title: 'WAREHOUSES',
          icon: 'warehouse',
          section: 'WAREHOUSE_MANAGEMENT',
        },
        component: loadView('Warehouses'),
        children: [
          {
            path: '',
            name: routeNames.WAREHOUSE,
            component: loadView('Warehouses/WarehouseList'),
            children: [],
          },
          {
            path: 'new',
            component: loadView('Warehouses/WarehouseForm'),
            name: routeNames.WAREHOUSE_NEW,
            meta: {
              title: 'NEW',
            },
          },
          {
            path: ':id',
            component: loadView('Warehouses/Warehouse'),
            name: 'warehouse',
            meta: {
              title: 'WAREHOUSE',
            },
            redirect: { name: routeNames.WAREHOUSE_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('Warehouses/WarehouseShow'),
                name: routeNames.WAREHOUSE_SHOW,
                props: route => ({
                  id: route.params.id,
                  tab: route.params.tab,
                }),
              },
              {
                path: 'edit',
                component: loadView('Warehouses/WarehouseForm'),
                name: routeNames.WAREHOUSE_EDIT,
                meta: {
                  title: 'EDIT',
                  icon: 'edit',
                },
                props: route => ({
                  id: route.params.id,
                }),
              },
              {
                path: 'import-load',
                component: loadView('Warehouses/WarehouseLoadImport'),
                name: routeNames.WAREHOUSE_LOAD_IMPORT,
                meta: {
                  title: 'IMPORT',
                  icon: 'edit',
                },
                props: route => ({
                  id: route.params.id,
                }),
              },
            ],
          },
        ],
      }, {
        path: '/warehouses_unload',
        meta: {
          title: 'WAREHOUSES_UNLOAD',
          icon: 'warehouse',
          section: 'WAREHOUSE_MANAGEMENT',
        },
        component: loadView('WarehousesUnload'),
        children: [
          {
            path: '',
            name: routeNames.WAREHOUSE_UNLOAD,
            component: loadView('WarehousesUnload/WarehouseUnloadList'),
            children: [],
          },
        ],
      }, {
        path: '/warehouses_load',
        meta: {
          title: 'WAREHOUSES_LOAD',
          icon: 'warehouse',
          section: 'WAREHOUSE_MANAGEMENT',
        },
        component: loadView('WarehousesLoad'),
        children: [
          {
            path: '',
            name: routeNames.WAREHOUSE_LOAD,
            component: loadView('WarehousesLoad/WarehouseLoadList'),
            children: [],
          },
        ],
      }, {
        path: '/warehouses_transfer',
        meta: {
          title: 'WAREHOUSES_TRANSFER',
          icon: 'warehouse',
          section: 'WAREHOUSE_MANAGEMENT',
        },
        component: loadView('WarehousesTransfer'),
        children: [
          {
            path: '',
            name: routeNames.WAREHOUSE_TRANSFER,
            component: loadView('WarehousesTransfer/WarehouseTransferList'),
            children: [],
          },
        ],
      }, {
        path: '/boxes',
        meta: {
          title: 'BOXES',
          icon: 'warehouse',
          section: 'WAREHOUSE_MANAGEMENT',
        },
        component: loadView('Box'),
        children: [
          {
            path: '',
            name: routeNames.BOXES,
            component: loadView('Box/BoxList'),
            children: [],
          },
        ],
      }, {
        path: '/campaign_teacher',
        meta: {
          title: 'CAMPAIGN_TEACHER',
          icon: 'campaign',
          section: 'CAMPAIGN_MANAGEMENT',
        },
        component: loadView('Campaigns'),
        children: [
          {
            path: '',
            name: routeNames.CAMPAIGN_TEACHER,
            component: loadView('Campaign/CampaignTeacher'),
            children: [],
          },
        ],
      }, {
        path: '/campaign_subject',
        meta: {
          title: 'CAMPAIGN_SUBJECT',
          icon: 'campaign',
          section: 'CAMPAIGN_MANAGEMENT',
        },
        component: loadView('Campaigns'),
        children: [
          {
            path: '',
            name: routeNames.CAMPAIGN_SUBJECT,
            component: loadView('Campaign/CampaignSubject'),
            children: [],
          },
        ],
      }, {
        path: '/campaign_school',
        meta: {
          title: 'CAMPAIGN_SCHOOL',
          icon: 'campaign',
          section: 'CAMPAIGN_MANAGEMENT',
        },
        component: loadView('Campaigns'),
        children: [
          {
            path: '',
            name: routeNames.CAMPAIGN_SCHOOL,
            component: loadView('Campaign/CampaignSchool'),
            children: [],
          },
        ],
      }, {
        path: '/campaign_school_result',
        meta: {
          title: 'CAMPAIGN_SCHOOL_RESULT',
          icon: 'campaign',
          section: 'CAMPAIGN_MANAGEMENT',
        },
        component: loadView('Campaigns'),
        children: [
          {
            path: '',
            name: routeNames.CAMPAIGN_SCHOOL_RESULT,
            component: loadView('Campaign/CampaignSchoolResult'),
            children: [],
          },
        ],
      },
      {
        path: '/campaign_report',
        meta: {
          title: 'REPORT',
          icon: 'campaign',
          section: 'CAMPAIGN_MANAGEMENT',
        },
        component: loadView('Campaigns'),
        children: [
          {
            path: '',
            name: routeNames.CAMPAIGN_REPORT,
            component: loadView('Campaign/CampaignReport'),
            children: [],
          },

          {
            path: 'campaign_report_sample',
            component: loadView('Campaign/reports/CampaignReportSample'),
            name: routeNames.CAMPAIGN_REPORT_SAMPLE,
            meta: {
              title: 'REPORT ASSEGNAZIONE SAGGI',
            },
          },

          {
            path: 'campaign_report_all',
            component: loadView('Campaign/reports/CampaignReportAll'),
            name: routeNames.CAMPAIGN_REPORT_ALL,
            meta: {
              title: 'REPORT ASSEGNAZIONE SAGGI',
            },
          },

          {
            path: 'campaign_report_booked',
            component: loadView('Campaign/reports/CampaignReportBooked'),
            name: routeNames.CAMPAIGN_REPORT_BOOKED,
            meta: {
              title: 'REPORT SAGGI PRENOTATI',
            },
          },

          {
            path: 'campaign_report_booked_order',
            component: loadView('Campaign/reports/CampaignReportBookedOrder'),
            name: routeNames.CAMPAIGN_REPORT_BOOKED_ORDER,
            meta: {
              title: 'ORDINI PRENOTATI',
            },
          },

          {
            path: 'campaign_report_ordered',
            component: loadView('Campaign/reports/CampaignReportOrdered'),
            name: routeNames.CAMPAIGN_REPORT_ORDERED,
            meta: {
              title: 'REPORT ORDINATI',
            },
          },

          {
            path: 'campaign_report_estimates',
            component: loadView('Campaign/reports/CampaignReportEstimates'),
            name: routeNames.CAMPAIGN_REPORT_ESTIMATES,
            meta: {
              title: 'CALCOLI MAGAZZINO',
            },
          },

          {
            path: 'campaign_report_estimates/:id',
            component: loadView('Campaign/reports/CampaignReportEstimateDetail'),
            name: routeNames.CAMPAIGN_REPORT_ESTIMATE_DETAIL,
            props: route => ({
              id: route.params.id,
            }),
            meta: {
              title: 'DETTAGLIO CALCOLO',
            },
          },
        ],
      },
      {
        path: '/roles',
        meta: {
          title: 'ROLES',
          icon: 'person',
        },
        component: loadView('Roles'),
        children: [
          {
            path: '',
            name: routeNames.ROLE,
            component: loadView('Roles/RoleList'),
            children: [],
          },
          {
            path: ':id',
            component: loadView('Roles/Role'),
            meta: {
              title: 'ROLE',
            },
            redirect: { name: routeNames.ROLE_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('Roles/RoleShow'),
                name: routeNames.ROLE_SHOW,
                props: route => ({
                  id: route.params.id,
                }),
              },
            ],
          },
        ],
      },
      {
        path: '/print_bullettins',
        meta: {
          title: 'PRINT_BULLETTINS',
          icon: 'print',
        },
        component: loadView('Print'),
        children: [
          {
            path: '',
            name: routeNames.PRINT_BULLETTINS,
            component: loadView('Print/PrintBulletin'),
            children: [],
          },
        ],
      }, {
        path: '/print_report',
        meta: {
          title: 'PRINT_REPORT',
          icon: 'print',
        },
        component: loadView('Print'),
        children: [
          {
            path: '',
            name: routeNames.PRINT_REPORT,
            component: loadView('Print/PrintReport'),
            children: [],
          },
        ],
      }, {
        path: '/adoptions',
        meta: {
          title: 'ADOPTION',
          icon: 'local_library',
          section: 'ADOPTION_MANAGEMENT',
        },
        component: loadView('Adoptions'),
        children: [
          {
            path: '',
            name: routeNames.ADOPTION,
            component: loadView('Adoptions/AdoptionList'),
            children: [],
          },
          {
            path: 'import',
            component: loadView('Adoptions/AdoptionImport'),
            name: routeNames.ADOPTION_IMPORT,
            meta: {
              title: 'IMPORT',
            },
          },
          {
            path: 'report',
            component: loadView('Adoptions'),
            meta: {
              title: 'REPORT',
            },
            children: [
              {
                path: '',
                component: loadView('Adoptions/AdoptionReport'),
                name: routeNames.ADOPTION_REPORT,
                meta: {
                  title: 'REPORT',
                },
              },
              {
                path: 'adoptions_report_propagandist_school',
                component: loadView('Adoptions/reports/AdoptionReportPropagandistSchool'),
                name: routeNames.ADOPTION_REPORT_PROPAGANDIST_SCHOOL,
                meta: {
                  title: 'REPORT ADOZIONE PROPAGANDISTA SCUOLA',
                },
              },
              {
                path: 'adoptions_report_school',
                component: loadView('Adoptions/reports/AdoptionReportSchool'),
                name: routeNames.ADOPTION_REPORT_SCHOOL,
                meta: {
                  title: 'REPORT ADOZIONE SCUOLA',
                },
              },

              {
                path: 'adoptions_report_editor',
                component: loadView('Adoptions/reports/AdoptionReportEditor'),
                name: routeNames.ADOPTION_REPORT_EDITOR,
                meta: {
                  title: 'REPORT ADOZIONE EDITORE',
                },
              },

              {
                path: 'adoptions_report_propagandist',
                component: loadView('Adoptions/reports/AdoptionReportPropagandist'),
                name: routeNames.ADOPTION_REPORT_PROPAGANDIST,
                meta: {
                  title: 'REPORT ADOZIONE PROPAGANDISTA',
                },
              },

              {
                path: 'adoptions_report_editor_propagandist',
                component: loadView('Adoptions/reports/AdoptionReportEditorPropagandist'),
                name: routeNames.ADOPTION_REPORT_EDITOR_PROPAGANDIST,
                meta: {
                  title: 'REPORT ADOZIONE EDITORE PROPAGANDISTA',
                },
              },

              {
                path: 'adoptions_report_propagandist_book',
                component: loadView('Adoptions/reports/AdoptionReportPropagandistBook'),
                name: routeNames.ADOPTION_REPORT_PROPAGANDIST_BOOK,
                meta: {
                  title: 'REPORT ADOZIONE LIBRO PROPAGANDISTA',
                },
              },

              {
                path: 'adoptions_report_editor_school',
                component: loadView('Adoptions/reports/AdoptionReportEditorSchool'),
                name: routeNames.ADOPTION_REPORT_EDITOR_SCHOOL,
                meta: {
                  title: 'REPORT ADOZIONE EDITORE SCUOLA',
                },
              },

              {
                path: 'adoptions_report_book_propagandist',
                component: loadView('Adoptions/reports/AdoptionReportBookPropagandist'),
                name: routeNames.ADOPTION_REPORT_BOOK_PROPAGANDIST,
                meta: {
                  title: 'REPORT ADOZIONE LIBRO PROPAGANDISTA',
                },
              },
              {
                path: 'adoptions_report_book_school',
                component: loadView('Adoptions/reports/AdoptionReportBookSchool'),
                name: routeNames.ADOPTION_REPORT_BOOK_SCHOOL,
                meta: {
                  title: 'REPORT ADOZIONE LIBRO SCUOLA',
                },
              },

              {
                path: 'adoptions_report_propagandist_editor',
                component: loadView('Adoptions/reports/AdoptionReportPropagandistEditor'),
                name: routeNames.ADOPTION_REPORT_PROPAGANDIST_EDITOR,
                meta: {
                  title: 'REPORT ADOZIONE PROPAGANDISTA EDITORE',
                },
              },

              {
                path: 'adoptions_report_school_total',
                component: loadView('Adoptions/reports/AdoptionReportSchoolTotal'),
                name: routeNames.ADOPTION_REPORT_TOTAL_SCHOOL,
                meta: {
                  title: 'REPORT ADOZIONE TOTALE SCUOLA',
                },
              },
            ],
          },
          {
            path: ':id',
            component: loadView('Adoptions/Adoption'),
            name: 'adoption',
            meta: {
              title: 'ADOPTION',
            },
            redirect: { name: routeNames.ADOPTION_SHOW },
            children: [
              {
                path: 'show',
                component: loadView('Adoptions/AdoptionShow'),
                name: routeNames.ADOPTION_SHOW,
                props: route => ({
                  id: route.params.id,
                  tab: route.params.tab,
                }),
              },
            ],
          },
        ],
      },
      {
        path: '/anomalies',
        meta: {
          title: 'ANOMALIES',
          icon: 'warning',
        },
        component: loadView('Anomalies'),
        children: [
          {
            path: '',
            name: routeNames.ANOMALY_DASHBOARD,
            component: loadView('Anomalies/AnomalyDashboard'),
            children: [],
          },
          {
            path: 'booked-zero',
            name: routeNames.ANOMALY_BOOKED_ZERO,
            component: loadView('Anomalies/reports/AnomalyBookedZero'),
          },
          {
            path: 'assigned-loop',
            name: routeNames.ANOMALY_ASSIGNED_LOOP,
            component: loadView('Anomalies/reports/AnomalyAssignedLoop'),
          },
          {
            path: 'duplicate',
            name: routeNames.ANOMALY_DUPLICATE,
            component: loadView('Anomalies/reports/AnomalyDuplicateAssignments'),
          },
          {
            path: 'booked-available',
            name: routeNames.ANOMALY_BOOKED_AVAILABLE,
            component: loadView('Anomalies/reports/AnomalyBookedButAvailable'),
          },
          {
            path: 'school-mismatch',
            name: routeNames.ANOMALY_SCHOOL_MISMATCH,
            component: loadView('Anomalies/reports/AnomalySchoolMismatch'),
          },
          {
            path: 'orders-missing',
            name: routeNames.ANOMALY_ORDERS_MISSING,
            component: loadView('Anomalies/reports/AnomalyOrdersMissing'),
          },
          {
            path: 'orphan-teachers',
            name: routeNames.ANOMALY_ORPHAN_TEACHERS,
            component: loadView('Anomalies/reports/AnomalyOrphanTeachers'),
          },
          {
            path: 'vqty-mismatch',
            name: routeNames.ANOMALY_VQTY_MISMATCH,
            component: loadView('Anomalies/reports/AnomalyVqtyMismatch'),
          },
        ],
      },
      {
        path: '/support',
        meta: {
          title: 'SUPPORT',
          icon: 'help_outline',
        },
        component: loadView('Support'),
        children: [
          {
            path: '',
            name: routeNames.SUPPORT,
            component: loadView('Support/SupportForm'),
            children: [],
          },
          {
            path: 'list',
            name: routeNames.SUPPORT_LIST,
            meta: {
              title: 'SUPPORT_MY_TICKETS',
            },
            component: loadView('Support/SupportList'),
          },
          {
            path: ':id',
            name: routeNames.SUPPORT_SHOW,
            meta: {
              title: 'SUPPORT_TICKET',
            },
            component: loadView('Support/SupportShow'),
            props: route => ({
              id: route.params.id,
            }),
          },
        ],
      },
    ],
  },
];

export { routes };
